(function () {

    "use strict";

    function workflowActivityService($resource,URL) {

        var self = this;
        
        self.resource = $resource(URL.URL +'/api/workflowactivity/:idFileItem', { idFileItem: '@_idFileItem' });
        self.resourceRelationsMetadatas = $resource(URL.URL +'/api/workflowactivity/:idWorkflowActivity/relationsMetadatas', { idWorkflowActivity: '@idWorkflowActivity' }, {
            put: { method: 'PUT' }
        });

        self.resourceMulti = $resource(URL.URL +'/api/workflowactivity/table');

    }

    workflowActivityService.$inject = ["$resource","URL"];

    angular.module("sphforms.workflow").service("sphforms.workflowActivityService", workflowActivityService);

})();